import type { SxProps } from '@mui/material';
import { ComponentViewMode } from '@/admins/SmartReports/components/Components/types';
import type { SlotsEnum } from '@/admins/SmartReports/components/Layouts/TitlePage/types';
import {
  TEXT_FIELD_PLACEHOLDER_ID,
  TextFieldPlaceholderView,
} from '@/admins/SmartReports/components/Placeholders/TextFieldPlaceholder/TextFieldPlaceholder';
import { buildPortfolioFromEntity } from '@/admins/SmartReports/helpers';
import { useGetPageComponent } from '@/admins/SmartReports/hooks/useGetPageComponent';
import type { SmartReportEntityExtended } from '@/admins/SmartReports/types';
import type { SmartReportPage } from '@/types/GraphqlSchema';

type SlotViewProps = {
  slotId: SlotsEnum;
  pageData: SmartReportPage;
  entity?: SmartReportEntityExtended;
  sx?: SxProps;
  mode?: ComponentViewMode.View;
};

export const SlotView = ({
  slotId,
  pageData,
  entity,
  mode = ComponentViewMode.View,
  sx,
}: SlotViewProps) => {
  const { slotData, componentId, slotConfig } = useGetPageComponent(pageData, slotId);

  if (componentId === TEXT_FIELD_PLACEHOLDER_ID) {
    // Special treatment for text field placeholders
    return <TextFieldPlaceholderView data={slotData} sx={sx} />;
  }

  if (!slotConfig) return <div />; // Return empty div if no config found

  const { ComponentView } = slotConfig;
  const portfolio = buildPortfolioFromEntity(entity);

  return <ComponentView portfolio={portfolio} data={slotData} sx={sx} mode={mode} />;
};
